import { useMemo } from 'react';
import { Photo } from '../types';

interface PhotoNavigationContext {
  filteredPhotos: Photo[];
  currentPhotoId: number | null;
}

interface PhotoNavigation {
  currentIndex: number;
  previousPhotoId: number | null;
  nextPhotoId: number | null;
  canNavigatePrevious: boolean;
  canNavigateNext: boolean;
}

export function usePhotoNavigation({
  filteredPhotos,
  currentPhotoId,
}: PhotoNavigationContext): PhotoNavigation {
  return useMemo(() => {
    const currentIndex = currentPhotoId
      ? filteredPhotos.findIndex(p => p.id === currentPhotoId)
      : -1;

    const isValidIndex = currentIndex >= 0 && currentIndex < filteredPhotos.length;

    const previousPhotoId = isValidIndex && currentIndex > 0
      ? filteredPhotos[currentIndex - 1].id
      : null;

    const nextPhotoId = isValidIndex && currentIndex < filteredPhotos.length - 1
      ? filteredPhotos[currentIndex + 1].id
      : null;

    return {
      currentIndex: isValidIndex ? currentIndex : -1,
      previousPhotoId,
      nextPhotoId,
      canNavigatePrevious: previousPhotoId !== null,
      canNavigateNext: nextPhotoId !== null,
    };
  }, [filteredPhotos, currentPhotoId]);
}
